module.exports = __webpack_public_path__ + "img/logo-ct-dark.7c300e4d.png";